import { render } from "./detailed.vue?vue&type=template&id=54b41f74"
import script from "./detailed.vue?vue&type=script&lang=js"
export * from "./detailed.vue?vue&type=script&lang=js"

import "./detailed.vue?vue&type=style&index=0&id=54b41f74&lang=css"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__